module.exports = __webpack_public_path__ + "static/img/200296.614ba850.png";